import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { withRouter } from 'react-router'
import Icon from 'react-fontawesome'
import styled from 'styled-components'

import Color from 'helpers/Color'
import Constants from 'helpers/Constants'
import Util from 'helpers/Util'
import Header from './Header'

// z-index for Background must be lower than Foreground's
const Background = styled.div`
  z-index: 10;
  position: fixed;
  width: 100vw;
  height: 100vh;
`
const Foreground = styled.div`
  z-index: 20;
  background-color: ${Color.white};
  ${Util.mobileOnly} {
    position: fixed;
    width: 100%;
    box-shadow: 0 0 20px 0px rgba(0, 0, 0, 0.4);
  }
`
const MenuBar = styled.div`
  padding: 8px 80px;
  max-width: ${Constants.pageWidth}px;
  margin: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;

  ${Util.mobileOnly} {
    display: ${({collapsed}) => collapsed ? 'none' : 'flex'};
    flex-direction: column;
  }
`
const MenuItem = styled(NavLink)`
  color: inherit;
  font-style: sans-serif;
  font-size: 1.4em;
  font-weight: bold;
  padding: 5px;
  white-space: nowrap;
  overflow: show;
  border-bottom: solid 4px transparent;

  ${Util.mobileOnly} {
    display: block;
    text-align: center;
    margin-bottom: 10px;
  }

  &.active {
    border-bottom: solid 4px ${Color.green};
  }

  &:hover {
    color: ${Color.green};
  }
`
const Description = styled.div`
  font-size: 0.75em;
  font-weight: 100;
`
const UserIcon = styled(Icon)`
  float: left;
  color: ${Color.green};
  margin-right: 10px;
`

// Check if this menu item should show as active with paths other than the
// destination url.
function handleItemActive (match, location, otherPaths) {
  if (match) return true
  if (!otherPaths) return false

  for (let path of otherPaths) {
    if (location.pathname.startsWith(path)) return true
  }
  return false
}

class MainMenu extends Component {
  state = {
    collapsed: true,
  }

  handleToggleClick = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    })
  }

  handleBackgroundClick = () => {
    this.setState({
      collapsed: true,
    })
  }

  render () {
    const { collapsed } = this.state

    const {
      role,
      items,
      user = {},
    } = this.props
    
    return (
      <div>
        { !collapsed &&
          <Background
            collapsed={this.state.collapsed}
            onClick={this.handleBackgroundClick}
          />
        }
        <Foreground>
        <Header onToggleClick={this.handleToggleClick} />
          <MenuBar collapsed={collapsed}>
            { items.map(item => (
              <MenuItem
                to={item.path}
                key={item.path}
                exact={item.exact}
                isActive={(match, location) => handleItemActive(match, location, item.otherPaths)}
              >
                {item.name}
              </MenuItem>
            ))
            }
            <MenuItem
              to='/user'
            >
              <UserIcon
                name='user-o'
                size='2x'
              />
              {`${user.givenName} ${user.familyName}`}
              <Description>{role}</Description>
            </MenuItem>
          </MenuBar>
        </Foreground>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  role: state.auth.role,
})

export default withRouter(connect(mapStateToProps)(MainMenu))



// WEBPACK FOOTER //
// ./src/components/App/MainMenu.jsx